import { Stack } from '@mui/material';
import { FormTextField } from 'src/components/Forms/FormTextField/form-text-field';
import {
  BLOCK_SHORT_TEXTAREA_PROPS,
  BLOCK_TEXT_FIELD_PROPS,
} from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/field-props';
import { blockFieldName } from 'src/pages/Settings/memberships/components/landing-page-tab/types';

interface ClosingCtaBlockFieldsProps {
  index: number;
  readOnly: boolean;
}

export const ClosingCtaBlockFields = ({ index, readOnly }: ClosingCtaBlockFieldsProps) => (
  <Stack gap={2.5}>
    <FormTextField
      type="textfield"
      name={blockFieldName(index, 'ctaHeadline')}
      label="Headline"
      required="Headline is required"
      disabled={readOnly}
      textFieldProps={BLOCK_TEXT_FIELD_PROPS}
    />

    <FormTextField
      type="textfield"
      name={blockFieldName(index, 'ctaSubtext')}
      label="Subtext"
      disabled={readOnly}
      textFieldProps={BLOCK_SHORT_TEXTAREA_PROPS}
    />

    <FormTextField
      type="textfield"
      name={blockFieldName(index, 'ctaButtonLabel')}
      label="Button label"
      required="Button label is required"
      disabled={readOnly}
      textFieldProps={BLOCK_TEXT_FIELD_PROPS}
    />
  </Stack>
);
